import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import useStyles from './styles';

type Props = {
    size?: number;
};

const BlockUi = (props: Props) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <CircularProgress size={props.size} />
        </div>
    );
};

export default BlockUi;
